import { render, staticRenderFns } from "./TruckMaintenanceReportTemplate.vue?vue&type=template&id=cb5a0dca"
import script from "./TruckMaintenanceReportTemplate.vue?vue&type=script&lang=js"
export * from "./TruckMaintenanceReportTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports